/**
 * 统一的API请求封装，处理认证、错误、响应格式化
 */

class APIClient {
  constructor(baseURL = 'http://localhost:4000/api') {
    // 使用真实后端API地址
    const runtimeUrl = (typeof window !== 'undefined' && window.APP_CONFIG && window.APP_CONFIG.API_URL)
      ? window.APP_CONFIG.API_URL
      : null;
    this.baseURL = runtimeUrl || import.meta.env.VITE_API_URL || baseURL;
    this.token = localStorage.getItem('aaa_auth_token');
  }

  /**
   * 通用请求方法
   */
  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };

    // 添加认证token
    if (this.token) {
      headers['Authorization'] = `Bearer ${this.token}`;
    }

    try {
      const response = await fetch(url, {
        ...options,
        headers,
        credentials: 'include',
      });

      // 处理401未授权
      if (response.status === 401) {
        // Don't log 401 as error - user might not be logged in
        this.handleUnauthorized();
        const error = new Error('Unauthorized');
        error.status = 401;
        throw error;
      }

      // 解析JSON响应
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `API Error: ${response.status}`);
      }

      return data;
    } catch (error) {
      // Don't log 401 as error - it's expected when not logged in
      if (error.status !== 401) {
        console.error('API Request failed:', error);
      }
      throw error;
    }
  }

  /**
   * GET 请求
   */
  async get(endpoint, params = {}) {
    const queryString = new URLSearchParams(params).toString();
    const url = queryString ? `${endpoint}?${queryString}` : endpoint;
    return this.request(url, { method: 'GET' });
  }

  /**
   * POST 请求
   */
  async post(endpoint, data) {
    return this.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  /**
   * PUT 请求
   */
  async put(endpoint, data) {
    return this.request(endpoint, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  }

  /**
   * DELETE 请求
   */
  async delete(endpoint) {
    return this.request(endpoint, { method: 'DELETE' });
  }

  /**
   * 设置认证token
   */
  setToken(token) {
    this.token = token;
    localStorage.setItem('aaa_auth_token', token);
  }

  /**
   * 清除认证token
   */
  clearToken() {
    this.token = null;
    localStorage.removeItem('aaa_auth_token');
  }

  /**
   * 处理未授权情况
   */
  handleUnauthorized() {
    this.clearToken();
    // 触发全局事件
    window.dispatchEvent(new CustomEvent('auth:logout'));
  }
}

// 导出单例
export const api = new APIClient();
